import { useEffect } from "react";

function upsertMeta(keyAttr, keyValue, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${keyAttr}="${keyValue}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(keyAttr, keyValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function usePageMeta(title, description, image) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    const origin = window.location.origin;
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", `${origin}${window.location.pathname}`);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    if (image) {
      upsertMeta("property", "og:image", `${origin}${image}`);
      upsertMeta("name", "twitter:image", `${origin}${image}`);
    }
  }, [title, description, image]);
}
